<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="500px"
    @keyup.enter.native="onSubmit()">
    <el-form ref="form"
             :model="form"
             label-width="60px">
      <el-form-item label="组名称"
                    prop="name">
        <el-input v-model="form.name"
                  placeholder="权限组名称"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary"
                   :disabled="!form.name"
                   @click="onSubmit()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    platformHost: {
      type: String
    }
  },
  data () {
    return {
      title: '',
      callback: Function.prototype,
      visible: false,
      form: {
        id: null,
        name: null,
        permission_ids: [],
      },
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    create (callback) {
      this.form.id = null
      this.form.name = null
      this.form.permission_ids = []
      this.title = '添加权限组'
      this.callback = callback
      this.visible = true
    },
    update (callback, data) {
      this.form.id = data.id
      this.form.name = data.name
      this.form.permission_ids = data.permission_ids
      this.title = '修改权限组'
      this.callback = callback
      this.visible = true
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.id ? this.updateRequest() : this.createRequest()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    createRequest () {
      request.common('createPermissionGroupData', {...this.form, host: this.platformHost}).then(({data}) => {
        this.$message.success('创建权限组成功！')
        this.callback(data)
        this.visible = false
      })
    },
    updateRequest () {
      request.common('updatePermissionGroupData', {...this.form, host: this.platformHost}).then(({data}) => {
        this.$message.success('修改权限组成功！')
        this.callback(data)
        this.visible = false
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-group/pages/PermissionGroupDialog.vue